import { render, staticRenderFns } from "./currencySettings.vue?vue&type=template&id=39a200c0&scoped=true"
import script from "./currencySettings.vue?vue&type=script&lang=js"
export * from "./currencySettings.vue?vue&type=script&lang=js"
import style0 from "./currencySettings.vue?vue&type=style&index=0&id=39a200c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39a200c0",
  null
  
)

export default component.exports